<template>
  <form class="form" :action="url" method="post" @submit.prevent="submit">
    <input
      type="text"
      id="nickname"
      name="nickname"
      v-model="userData.nickname"
      placeholder="Выдача наград завершена"
      disabled
      required
    />

    <button
      type="submit"
      class="button"
      :class="{ 'form__button-sended': sended }"
      disabled
    >
      <img src="../assets/img/arrow-right.svg" />
    </button>
  </form>
</template>

<script>
import axios from "axios";
import grConfig from "./gr_config.js";

export default {
  data() {
    return {
      url: "https://specials.pikabu.ru/ps5-game/api/send",
      recaptchaConfig: grConfig,
      isSending: false,
      sended: false,
      userData: {
        nickname: ""
      }
    };
  },
  methods: {
    submit() {
      this.isSending = true;
      let self = this;

      // eslint-disable-next-line no-undef
      grecaptcha.ready(function() {
        // eslint-disable-next-line no-undef
        grecaptcha
          .execute(self.recaptchaConfig[0].grkey, { action: "send" })
          .then(function(token) {
            axios
              .post(self.url, {
                headers: { "X-Requested-With": "XMLHttpRequest" },
                responseType: "json",
                data: self.userData,
                params: {
                  rg: token
                }
              })
              .then(function(response) {
                if (response.data.result) {
                  self.sended = true;
                  self.$store.commit("toggleModal", "formSend");
                  setTimeout(
                    () => self.$store.commit("toggleModal", "formSend"),
                    3000
                  );
                }
                self.isSending = false;
              })
              .catch(function() {
                // console.log(error.response);
                // console.log(error.response.status);
                self.isSending = false;
              });
          });
      });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.form {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  column-gap: 4px;
  min-width: 286px;

  .button {
    padding: 8px 17px;

    img {
      transition: all 0.15s ease;
    }
  }
}

.form__button-sended {
  background-color: #76d13b;
  border-color: #e8ff65;
  box-shadow: 0px 6px 0px -1px #76d13b, 0px 6px 0px #e8ff65;

  img {
    transform: rotate(90deg);
  }
}
</style>
